import api from './api';

export type BudgetStatus = 'pre-target' | 'target-reached' | 'expired' | 'disabled';

export interface Budget {
  enabled: boolean;
  // Raw NTS
  valore: number;
  percentuale: number;
  mesiPeriodo: number;
  fatturatoCorrente: number;
  dataInizio: string | null;
  // Derivati
  dataScadenza: string | null;
  giorniMancanti: number | null;
  targetMancante: number;
  targetRaggiunto: boolean;
  eccedenzaSoglia: number;
  risparmioStimato: number;
  progressoVersoTarget: number;
  status: BudgetStatus;
  updatedAt: string | null;
  anConto?: number | null;
}

/**
 * Risposta di POST /api/clienti/me/cart/preview-budget — usata dal
 * CartContext per mostrare l'anteprima sconto premium nella drawer.
 */
export interface CartBudgetBreakdown {
  applicable: boolean;
  status: BudgetStatus;
  percentuale: number;
  subtotale: number;
  porzionePreTarget: number;
  porzionePostTarget: number;
  scontoApplicato: number;
  totaleFinale: number;
  fatturatoCorrente: number;
  nuovoFatturatoCorrente: number;
  eccedenzaSoglia: number;
  crossesThresholdNow: boolean;
}

export const budgetService = {
  /** Budget del cliente loggato (TTL cache 1h, force-refresh con flag). */
  async getMine(force = false): Promise<Budget> {
    const { data } = await api.get<Budget>('/api/clienti/me/budget', {
      params: force ? { refresh: 1 } : undefined,
    });
    return data;
  },

  /** Admin: legge il budget di un cliente specifico (sempre live da NTS). */
  async getByConto(anConto: number): Promise<Budget> {
    const { data } = await api.get<Budget>(`/api/admin/clienti/${anConto}/budget`);
    return data;
  },

  /** Anteprima sconto budget premium per il carrello corrente (Fase 2). */
  async previewCart(subtotale: number): Promise<CartBudgetBreakdown> {
    const { data } = await api.post<CartBudgetBreakdown>(
      '/api/clienti/me/cart/preview-budget',
      { subtotale },
    );
    return data;
  },
};
